module.exports = __webpack_public_path__ + "img/refresh.c92f9354.svg";